import React from 'react';
import { Box, Button, Card } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import { styles } from '../CRPolicies/styles';
import PermissionChecker from '../../../components/common/PermissionChecker';

export const CRPoliciesSaveMappings = ({
    selectedPositions,
    viewMappedPositionsShow,
    updatePolicyMappings,
    handelBulkUpdate,
}) => {
    return (
        <>
            <Card sx={{ ...styles.filterMenu, marginBottom: '30px' }}>
                <Box sx={styles.filterButtons}>
                    {viewMappedPositionsShow ? (
                        <PermissionChecker
                            requiredPermissions={[
                                'ROLE_BASE_PERMISSION_RECRUIT_INDEX_MAP_POSITION_TO_CHANGE_REQUEST_POLICY',
                            ]}
                            noAuthRedirect={false}
                        >
                            <Button
                                sx={styles.viewMappedButton}
                                size="large"
                                variant="contained"
                                onClick={handelBulkUpdate}
                                startIcon={!updatePolicyMappings ? <EditIcon /> : <CheckIcon />}
                                disabled={!selectedPositions.length && updatePolicyMappings}
                            >
                                {!updatePolicyMappings ? ' Update Policy Mappings' : 'Save Mappings'}
                            </Button>
                        </PermissionChecker>
                    ) : (
                        <></>
                    )}
                </Box>
            </Card>
        </>
    );
};
